import React from 'react';
import './Banner.css';

import { Button, Heading } from '../../../components';
import { FaHeadset } from 'react-icons/fa';



const Banner = () => {

  return (
    <section className="banner">
      <div className='content'>

        <div className='banner-1'>
          <Heading title={"Join Us in Promoting Locksmith Excellence"} subTitle={"Ensuring Property Security"} linear sideHeading />
          <Button link={"Get-Quote"} title={"Get A Quote"} />
        </div>

        <div className='banner-2'>
          <h4>Emergency Helpline</h4>
          <div className='banner-icon'>
            <span></span><div className='icon'><FaHeadset /></div><span></span>
          </div>
          <h6>111-222-333</h6>
          <Button link={"Contact-us"} title={"Contact Us"} />
        </div>

      </div>
    </section>
  );

};

export default Banner;